import { createGlobalState } from 'react-use';

const useCreateModal = createGlobalState(false);
const renameModal = createGlobalState(false);
const moveModal = createGlobalState(false);
const deleteModal = createGlobalState(false);

export enum CreativeLibraryFolderModals {
  Create = 'create',
  Rename = 'rename',
  Move = 'move',
  Delete = 'delete',
}
/**
 * This hook creates a global state that can be used to track template folder modals and selectively
 * open and close them from any component without having to pass props around
 */
export function useCreativeLibraryFolderModals() {
  const [showCreateModal, setShowCreateModal] = useCreateModal();
  const [showRenameModal, setShowRenameModal] = renameModal();
  const [showMoveModal, setShowMoveModal] = moveModal();
  const [showDeleteModal, setShowDeleteModal] = deleteModal();

  return {
    [CreativeLibraryFolderModals.Create]: {
      isShown: showCreateModal,
      toggle: (newState?: boolean) => {
        setShowCreateModal(newState ?? !showCreateModal);
      },
    },
    [CreativeLibraryFolderModals.Rename]: {
      isShown: showRenameModal,
      toggle: (newState?: boolean) => {
        setShowRenameModal(newState ?? !showRenameModal);
      },
    },
    [CreativeLibraryFolderModals.Move]: {
      isShown: showMoveModal,
      toggle: (newState?: boolean) => {
        setShowMoveModal(newState ?? !showMoveModal);
      },
    },
    [CreativeLibraryFolderModals.Delete]: {
      isShown: showDeleteModal,
      toggle: (newState?: boolean) => {
        setShowDeleteModal(newState ?? !showDeleteModal);
      },
    },
  };
}
